import React from 'react';

const GroupsScrollingContext = React.createContext<{
  determineIfIsScrolling: () => void;
}>({
  determineIfIsScrolling: window.tokenFunction,
});

export default GroupsScrollingContext;
